<template>
  <section class="container">
    <div class="card-wrap mt-20 mb-20">
      <el-tabs>
        <el-row :gutter="24">
          <el-col :span="14">
            <div class="grid-content bg-purple">
              <span>文件信息</span>
              <el-form
                ref="qrForm"
                class="add-form"
                label-width="100px"
                label-position="left"
                style="margin-top: 3%"
              >
                <div class="add-form-item">
                  <el-form-item label="标题：" prop="title">
                    <el-input v-model="title" />
                  </el-form-item>
                </div>
                <div class="add-form-item">
                  <el-form-item label="文件：" prop="title">
                    <el-upload
                      ref="upload"
                      :data="uploadData"
                      :action="fileUrl"
                      :limit="1"
                      :headers="getHeaders"
                      :file-list="fileList"
                      :on-error="handleError"
                      :on-progress="handleProgress"
                      :before-upload="handleBeforeUpload"
                      :on-success="handleSuccess"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                    </el-upload>
                  </el-form-item>
                </div>
                <br />
                <div class="add-form-item">
                  <el-form-item>
                    <span class="validate ml-20">
                      注:目前只能上传'jpg','jpeg','gif','png','bmp','pdf','doc','docx*','ppt','pptx','pot','potx','xls',
                      'xlsx','txt','rtf','et','wps','dps','mp3','mp4','wma',,'mid','apk','mov'
                    </span>
                  </el-form-item>
                </div>
                <div class="add-form-item">
                  <el-form-item>
                    <el-button type="primary" @click="saveMarketing"
                      >生成二维码</el-button
                    >
                    <el-button type="primary" @click="downloadQrcode"
                      >下载二维码</el-button
                    >
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-col>
          <div
            style="float:left;width: 1px;height: 500px; background: #d4d4d4;"
          ></div>
          <div>
            <QrCodeInfo
              ref="qrCodeInfo"
              @getFileInfoList="getFileInfoList"
              :dataInfo="dataInfo"
            />
          </div>
        </el-row>
      </el-tabs>
    </div>
    <br />
    <div>
      <el-table :data="list" style="width: 100%" border class="mt-40">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标题" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="内容" :fit="true">
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleShow(scope.row)"
              >查看</el-button
            >
            <el-button type="danger" size="mini" @click="deleteFile(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import QrCodeInfo from "./webQrCodeInfo.vue";
import Setting from "@/config/setting";
import VueCookie from "@/config/util.cookies";
import { Loading } from "element-ui";

export default {
  components: {
    QrCodeInfo
  },
  data() {
    return {
      list: [],
      title: "",
      uploadData: {
        fileName: ""
      },
      fileUrl: Setting.fileUrl,
      getHeaders: {
        Authorization: "Bearer " + VueCookie.get("token")
      },
      qrCodeUrl: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      fileList: [],
      dataInfo: {},
      loader: ""
    };
  },
  methods: {
    //生成二维码
    saveMarketing() {
      let _this = this;
      if (
        _this.title === "" ||
        _this.title === null ||
        _this.title === undefined
      ) {
        _this.$message.error("请输入标题!");
      }
      if (
        _this.qrCodeUrl === "" ||
        _this.qrCodeUrl === null ||
        _this.qrCodeUrl === undefined
      ) {
        _this.$message.error("请上传文件!");
      }
      let fileArray = _this.qrCodeUrl.split("file/");

      let fileInfo = {
        title: _this.title,
        content: fileArray[0] + "file/" + encodeURIComponent(fileArray[1])
      };
      _this.$refs.qrCodeInfo.createCode(fileInfo, 3);
    },
    //下载二维码
    downloadQrcode() {
      let _this = this;
      _this.$refs.qrCodeInfo.downloadQrcode();
    },
    getFileInfoList() {
      let _this = this;
      let param = {
        url: "/api/textAndFile/getFilePage",
        params: {
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };
      _this.$store.dispatch("getFileList", param).then(() => {
        _this.list = _this.$store.state.newQrCode.fileList.list;
        _this.total = _this.$store.state.newQrCode.fileList.total;
      });
    },
    handleError() {
      let _this = this;
      _this.loader.close();
      _this.$message({
        message: "文件上传失败!",
        type: "warning"
      });
      _this.fileList = [];
    },
    handleProgress(event, file, fileList) {
      let _this = this;
      _this.loader = Loading.service({
        lock: true,
        text: "文件正在上传中,请勿关闭或操作浏览器,以免文件上传失败!",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    handleSuccess(response, file, fileList) {
      let _this = this;
      _this.loader.close();
      if (response.status == 200) {
        _this.qrCodeUrl = response.data;
        _this.$message({
          message: "文件上传成功!",
          type: "success"
        });
      } else {
        _this.$message({
          message: "文件上传失败!",
          type: "warning"
        });
        fileList = [];
      }
    },
    handleBeforeUpload(file) {
      let _this = this;
      _this.uploadData.fileName = file.name;
      if (file.size > 524288000) {
        _this.$message({
          message: "最大只能上传500MB文件!",
          type: "error"
        });
        return false;
      }
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getFileInfoList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getFileInfoList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getFileInfoList();
    },
    //删除
    deleteFile: function(row) {
      let _this = this;
      _this
        .$confirm("确定要删除该条文件二维码吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let param = {
            url: "/api/textAndFile/deleteTextAndFileById",
            params: { id: row.id }
          };
          _this.$Api
            .get(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.getFileInfoList();
                _this.$message({
                  message: "文件二维码删除成功",
                  type: "success"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        });
    },
    handleShow(info) {
      let _this = this;
      _this.fileList = [];
      _this.title = info.title;
      _this.qrCodeUrl = info.content;
      let urlStr = info.content.split("file/");
      _this.fileList.push({
        name: decodeURIComponent(urlStr[urlStr.length - 1]),
        url: info.content
      });
      _this.dataInfo = {
        data: info.content,
        logoSrc: info.logo,
        size: info.size,
        foreColor: info.foreColor,
        backColor: info.backColor,
        formWork: info.formWork,
        faultToleRance: info.faultToleRance
      };
    }
  },
  created() {
    let _this = this;
    _this.getFileInfoList();
  }
};
</script>

<style lang="sass" scoped>
.pagination
    text-align: center
.validate
    height: 110px
    font-size: 13px
    color: #E6A23C
</style>
